<div class="container pt-5 pb-5">
  <div class="header-summary text--center">
    <h5>What happened to my old plan?</h5>
    <div class="header-summary__content text--left mt-3">
      <i class="fa-regular fa-exclamation-circle"></i>
      <p>
        <strong
          >Your plan
          <span class="plan-number">{{ currentPlan?.plan_number }}</span> has
          ended.</strong
        >
        But don’t worry, you’ll be covered when you buy a new policy.
      </p>
    </div>
  </div>
</div>
